import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Paper, Grid, Typography, Button, Link } from '@material-ui/core';
import BlockIcon from '@material-ui/icons/Block';
import EditIcon from '@material-ui/icons/Edit';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';

import { branchStatus } from '../../constants';
import DeactiveOrDeleteBranchDialog from './../../containers/DeativeOrDeleteBranchDialog';
import EditBranchDialog from '../../containers/EditBranchDialog';

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(2),
    paddingLeft: theme.spacing(3),
    marginBottom: theme.spacing(1)
  },
  companyName: {
    fontSize: 18,
    fontWeight: 800,
    paddingTop: theme.spacing(1)
  },
  email: {
    paddingTop: theme.spacing(1)
  },
  deactivateContainer: {},
  editDeleteContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  },
  editButton: {
    color: theme.palette.secondary.main
  },
  deleteButton: {
    color: theme.palette.danger.main
  },
  root: { marginBottom: 20 },
  branchList: {
    height: '100%',
    overflowY: 'auto',
    padding: 0,
    marginBottom: 20
  }
}));

const mapComapnyIdToCompanyName = (allCompanies, companyId) => {
  var selectedCompany = allCompanies.filter((c) => c.id === companyId)[0];
  return selectedCompany ? selectedCompany.name : 'Inconsistent Data';
};

const SingleBranch = (props) => {
  const classes = useStyles();

  const {
    branch,
    allCompanies,
    handleBranchEditClick,
    openDeleteOrDeactiveBranchDialog
  } = props;
  const branchId = branch.id;

  React.useEffect(
    () => {},

    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  let companyName = '';
  if (allCompanies && allCompanies.length > 0) {
    companyName = mapComapnyIdToCompanyName(allCompanies, branch.companyId);
  }

  return (
    <Paper>
      <div className={classes.container}>
        <Grid container>
          <Grid item xs={6}>
            <div className={classes.companyDetails}>
              <Typography variant="h3" className={classes.companyName}>
                {branch && branch.name}
              </Typography>
              <Typography variant="subtitle1" className={classes.email}>
                {companyName}
              </Typography>
            </div>
          </Grid>
          <Grid item xs={3}>
            <div className={classes.deactivateContainer}>
              <Button
                startIcon={<BlockIcon />}
                onClick={() =>
                  openDeleteOrDeactiveBranchDialog(
                    true,
                    branchId,
                    branchStatus.DEACTIVE
                  )
                }
                style={{ display: 'none' }}
              >
                Deactivate
              </Button>
              <Link
                href={`/admin-view/branch/${branchId}`}
                target="_blank"
                className={classes.viewAsAdminButton}
              >
                View as admin
              </Link>
            </div>
          </Grid>
          <Grid item xs={3}>
            <div className={classes.editDeleteContainer}>
              <Button
                startIcon={<EditIcon />}
                className={classes.editButton}
                onClick={() => handleBranchEditClick({ ...branch })}
              >
                Edit
              </Button>
              <Button
                startIcon={<DeleteOutlineIcon />}
                className={classes.deleteButton}
                onClick={() =>
                  openDeleteOrDeactiveBranchDialog(
                    true,
                    branchId,
                    branchStatus.DELETE
                  )
                }
              >
                Delete
              </Button>
            </div>
          </Grid>
        </Grid>
      </div>
    </Paper>
  );
};

function BranchesList(props) {
  const classes = useStyles();
  const {
    branches,
    fetchAllBranches,
    onBranchEditClick,
    openDeleteOrDeactiveBranchDialog,
    companies,
    fetchAllCompanies
  } = props;
  React.useEffect(() => {
    fetchAllBranches();
    if (companies && companies.length === 0) {
      fetchAllCompanies();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlDeleteOrDeactiveBranchDialog = (open, branchId, status) => {
    openDeleteOrDeactiveBranchDialog(open, branchId, status);
  };

  const handleBranchEditClick = (branch) => {
    onBranchEditClick(branch);
  };

  return (
    <React.Fragment>
      <DeactiveOrDeleteBranchDialog />
      <EditBranchDialog />
      <div className={classes.companiesListContainer}>
        {branches &&
          branches.map((branch) => {
            return (
              <SingleBranch
                branch={branch}
                key={branch.id}
                openDeleteOrDeactiveBranchDialog={
                  handlDeleteOrDeactiveBranchDialog
                }
                handleBranchEditClick={handleBranchEditClick}
                allCompanies={companies}
              />
            );
          })}
      </div>
    </React.Fragment>
  );
}

export default BranchesList;
